import Vue from "vue";
import { IonicVueRouter } from "@ionic/vue";
import Main from "./views/Main.vue";
import Reports from "./views/Reports.vue";
import ReportDetail from "./views/ReportDetail.vue";

// import Status from "./views/Status.vue";
// import Repairs from "./views/Repairs.vue";
// import Maintenance from "./views/Maintenance.vue";
// import Parts from "./views/Parts.vue";
import TakeFotoElement from "./components/TakeFotoElement.vue";
import ScanQrCodeElement from "./components/ScanQrCodeElement.vue";
import SpeechToTextElement from "./components/SpeechToTextElement.vue";

Vue.use(IonicVueRouter);

export default new IonicVueRouter({
  mode: "history",
  routes: [
    { path: "/", redirect: "main" },
    {
      path: "/main",
      name: "main",
      component: Main
    },
    {
      path: "/reports",
      name: "reports",
      component: Reports
    },
    {
      path: "/report_detail/:id",
      name: "report_detail",
      component: ReportDetail
    }
    // {
    //   path: "/status",
    //   name: "status",
    //   component: Status
    // }
    // {
    //   path: "/repairs",
    //   name: "repairs",
    //   component: Repairs
    // },
    // {
    //   path: "/maintenance",
    //   name: "maintenance",
    //   component: Maintenance
    // },
    // {
    //   path: "/parts",
    //   name: "parts",
    //   component: Parts
    // },
    // {
    //   path: "/pgphoto",
    //   name: "pgphoto",
    //   component: TakeFotoElement
    // },
    // {
    //   path: "/pgqrcode",
    //   name: "pgqrcode",
    //   component: ScanQrCodeElement
    // },
    // {
    //   path: "/pgspeech",
    //   name: "pgspeech",
    //   component: SpeechToTextElement
    // }
  ]
});
